import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  desassociarUsuarioTpDrive,
  getCelularesAppTpDrive,
  updateCelularTpDrive,
} from '../../../../services/api/https/system/system.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  CustomPanel,
  DateTime,
  InputDate,
  InputText,
  Loading,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { DataTable } from 'primereact/datatable'
import { FaTrash } from 'react-icons/fa'

function CelularAppExpedicao({ history, dispatch, selectedTp }) {
  // Vars
  const novoCelular = {
    codigo_ativacao: '',
    ativado: 0,
    data_ativacao: '',
    habilitado: 1,
    tp_id: selectedTp,
  }

  // Hooks
  const [celulares, setCelulares] = useState([])
  const [showCelularModal, setShowCelularModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedCelular, setSelectedCelular] = useState(novoCelular)

  // Events
  const onBtnVoltar = () => {
    history.goBack()
  }
  const onModalCelularClose = () => {
    setShowCelularModal(false)
  }
  const onModalCelularSuccess = celular => {
    const index = celulares.findIndex(c => c.id === celular.id)
    if (index === -1) {
      setCelulares([...celulares, celular])
    } else {
      const newCelulares = [...celulares]
      newCelulares[index] = { ...newCelulares[index], ...celular }
      setCelulares(newCelulares)
    }
    setShowCelularModal(false)
    dispatch(showMessageBox('Operação realizada com sucesso', null))
  }

  const onModalCelularError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onModalUsuarioError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onMenuItemClick = (menuItem, celular) => {
    setSelectedCelular(celular)
    switch (menuItem) {
      case 'Editar':
        setShowCelularModal(true)
        break
      default:
        break
    }
  }

  // Hooks
  useEffect(() => {
    _getCelulares()
  }, [selectedTp])

  // Helpers
  const _getCelulares = async () => {
    try {
      const celulares = await getCelularesAppTpDrive(selectedTp)
      setCelulares(celulares)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>
        S.26 - Celulares -&nbsp;<strong>Aplicativo Tp Drive</strong>&nbsp;- Por TP
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={onBtnVoltar}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <CelularesDataTable
              celulares={celulares}
              onMenuItemClick={onMenuItemClick}
              onModalUsuarioError={onModalUsuarioError}
              _getCelulares={_getCelulares}
            />
          )}
        </CustomPanel>
      </div>
      {showCelularModal ? (
        <CelularModal
          celular={selectedCelular}
          onModalClose={onModalCelularClose}
          onModalSuccess={onModalCelularSuccess}
          onModalError={onModalCelularError}
        />
      ) : null}
    </div>
  )
}

function CelularesDataTable({ celulares, onMenuItemClick, onModalUsuarioError, _getCelulares }) {
  const onDeleteAssoc = async assoc_id => {
    try {
      await desassociarUsuarioTpDrive(assoc_id)
      await _getCelulares()
    } catch (e) {
      onModalUsuarioError(e)
    }
  }
  const [globalFilter, setGlobalFilter] = useState('')
  return (
    <DataTable
      emptyMessage="Não existem códigos de ativação gerados"
      value={celulares}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="codigo_ativacao" header="Código de Ativação" />
      <Column field="driver_name" header="Nome Motorista" />
      <Column field="driver_cnh" header="CNH Motorista" />
      <Column
        field="ativado"
        header="Ativado"
        style={tableCellCentered()}
        body={celular => <CustomCheckbox disabled={true} checked={celular.ativado === 1} />}
      />
      <Column
        field="data_ativacao"
        header="Data da Ativação"
        style={tableCellCentered(150)}
        body={celular =>
          celular.data_ativacao ? (
            <DateTime>{new Date(celular.data_ativacao).toISOString()}</DateTime>
          ) : null
        }
      />
      <Column
        field="habilitado"
        header="Habilitado"
        style={tableCellCentered()}
        body={celular => <CustomCheckbox disabled={true} checked={celular.habilitado === 1} />}
      />
      <Column
        header="Menu"
        style={tableCellCentered()}
        body={celular => (
          <ThreeDots items={['Editar']} onClick={item => onMenuItemClick(item, celular)} />
        )}
      />
      <Column
        header=""
        style={tableCellCentered(70)}
        body={item => (
          <FaTrash
            style={{ cursor: 'pointer' }}
            color="red"
            onClick={async () => await onDeleteAssoc(item.id)}
          />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

function CelularModal({ celular, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [selectedCelular, setSelectedCelular] = useState(celular)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onFormChange = (name, value) => {
    const newState = { ...selectedCelular }
    newState[name] = value
    setSelectedCelular(newState)
  }

  const onModalSalvarClick = async () => {
    try {
      setIsLoading(true)
      const celular = await updateCelularTpDrive({
        ...selectedCelular,
        habilitado: selectedCelular.habilitado ? 1 : 0,
      })
      onModalSuccess(celular)
    } catch (e) {
      setIsLoading(false)
      onModalError(e)
    }
  }
  //Render
  return (
    <CustomModal header={'Editando Celular'} isVisible={true} onClose={onModalClose}>
      <div className="p-grid">
        <div className="p-col-6">
          <InputText
            marginTop={0}
            label="Código de Ativação"
            value={selectedCelular.codigo_ativacao}
            onChange={value => onFormChange('codigo_ativacao', value.toUpperCase())}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 30 }}>
          <CustomCheckbox
            checked={selectedCelular.habilitado === 1 || selectedCelular.habilitado === true}
            onChange={value => onFormChange('habilitado', value)}
          >
            Habilitado
          </CustomCheckbox>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-6">
          <InputDate
            marginTop={0}
            disabled={true}
            value={selectedCelular.data_ativacao}
            label="Data de Ativação"
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 30 }}>
          <CustomCheckbox disabled={true} checked={selectedCelular.ativado === 1}>
            Ativado
          </CustomCheckbox>
        </div>

        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onModalSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CelularAppExpedicao))
